var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeactiveCouponFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 4.25C1.5 3.83579 1.83579 3.5 2.25 3.5H13.75C14.1642 3.5 14.5 3.83579 14.5 4.25V6.26756C13.9022 6.61337 13.5 7.25972 13.5 8C13.5 8.74028 13.9022 9.38663 14.5 9.73244V11.75C14.5 12.1642 14.1642 12.5 13.75 12.5H2.25C1.83579 12.5 1.5 12.1642 1.5 11.75V9.73244C2.0978 9.38663 2.5 8.74028 2.5 8C2.5 7.25972 2.0978 6.61337 1.5 6.26756V4.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 4V4.5M11 6.5V7M11 9V9.5M11 11.5V12M5 8.5H8.5M5 10H7M2.25 3.5C1.83579 3.5 1.5 3.83579 1.5 4.25V6.26756C2.0978 6.61337 2.5 7.25972 2.5 8C2.5 8.74028 2.0978 9.38663 1.5 9.73244V11.75C1.5 12.1642 1.83579 12.5 2.25 12.5H13.75C14.1642 12.5 14.5 12.1642 14.5 11.75V9.73244C13.9022 9.38663 13.5 8.74028 13.5 8C13.5 7.25972 13.9022 6.61337 14.5 6.26756V4.25C14.5 3.83579 14.1642 3.5 13.75 3.5H2.25Z",
    stroke: "#1F1F1F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactiveCouponFilter);
export default __webpack_public_path__ + "static/media/deactive-coupon-filter.24126d344d4705d21edbf185b9e3e5eb.svg";
export { ForwardRef as ReactComponent };